import React from "react";

const ShippingDelivery = () => {
  return (
    <main>
      {/* breadcrumb start */}
      <section id="h1-breadcrumb">
        <div className="h1-breadcrumb w-full h-fit overflow-hidden relative bg-main-gray pb-16 md:pb-[120px]">
          <img
            src="./assets/images/home-nine/hero-bg.png"
            alt=""
            className="absolute z-0 mx-auto cta_bg_anim h-full w-full"
          />

          <div
            className="win-grid win-grid-bg w-full h-full absolute left-0 top-0 z-0"
            id="win-grid"
          />
          <div className="absolute left-1/4 w-full top-[300px] overflow-hidden z-0 pointer-events-none">
            <div className="flex justify-center">
              <img src="assets/images/home-one-hero-circle-shadow.svg" alt="" />
            </div>
          </div>
          <div className="theme-container mx-auto h-fit w-fit relative z-0">
            <div className="mt-[120px] md:mt-[200px] w-fit mx-auto relative">
              <h1
                data-aos="fade"
                className="text-main-black text-34 font-semibold w-full text-center max-w-[500px]"
              >
                Shipping & Delivery Policy
              </h1>
            </div>
          </div>
        </div>
      </section>
      {/* breadcrumb end */}

      {/* blog start  */}
      <section className="w-full py-16 md:py-[130px]" data-aos="fade">
        <div className="theme-container mx-auto w-full">
          <i className="text-[14px] mb-2 inline-block font-semibold">
            Last updated on Jan 29th 2025
          </i>
          <ul>
            <li className="mb-2">
              1. Service orders are fulfilled by our empaneled health providers
              through their qualified technicians or phlebotomist or staff.
            </li>
            <li className="mb-2">
              2. Product orders are shipped through registered domestic courier
              companies and /or speed post only.
            </li>
            <li className="mb-2">
              3. Orders are shipped within 0-7 days or as per the delivery date
              agreed at the time of order confirmation and delivering of the
              shipment subject to availability of product / subject to Courier
              Company / post office norms.
            </li>
            <li className="mb-2">
              4. ClickForDoctor is not liable for any delay in delivery by the
              courier company / postal authorities and only guarantees to hand
              over the consignment to the courier company or postal authorities
              within 0-7 days rom the date of the order and payment or as per
              the delivery date agreed at the time of order confirmation.
            </li>
            <li className="mb-2">
              5. Delivery of all orders will be to the address provided by the
              buyer.
            </li>
            <li className="mb-2">
              6. Delivery of our services will be confirmed on your mail ID as
              specified during registration. For any issues in utilising our
              services you may contact our help desk on
              <a className="pr-[4px] text-theme font-semibold cursor-pointer" href="tel:919711300776" style={{ display: "inline-block" }}>
               +91-9711300776
              </a>
              or
              <a className="px-[4px] text-theme font-semibold cursor-pointer" href="mailto:support@clickfordoctor.com" style={{ display: "inline-block" }}>
                support@clickfordoctor.com
              </a>
              .
            </li>
          </ul>
        </div>
      </section>
      {/* blog end  */}
    </main>
  );
};

export default ShippingDelivery;
